import { PhysicalStopAPI } from '../../../api/datamanager/PhysicalStopAPI';

export class PhysicalStopsCommand {
    getAll(successCallback, errorCallback) {
        const apiResult = PhysicalStopAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Paragens");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/PhysicalStopsCommand.js